import { Dialog as InitialDialog } from "@mui/material";
import { useEffect, useRef } from "react";

export default function Dialog({ children, open, ...props }) {
  const lastOpen = useRef(Boolean(open));

  useEffect(() => {
    if (lastOpen.current == Boolean(open)) return;
    lastOpen.current = Boolean(open);

    if (open) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <InitialDialog open={open} {...props}>
      {children}
    </InitialDialog>
  );
}
